<ng-container *ngIf="['createTest', 'updateTest'].includes(action)">
	<app-form-view [popup]="true">
		<form-title>
			{{title}}
		</form-title>
		<content-area>
			<div class="assessment-form" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="30px">
				<div fxLayout="row" fxLayoutAlign="center start">
					<div fxFlex="80%" fxFlex.xs="100%" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
						<ng-container *ngIf="info">
							<div class="form-info">
								<p class="body-text">
									{{info}}
								</p>
							</div>
						</ng-container>
						<div fxLayout="row" fxLayoutAlign="center center">
							<div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="95" fxFlex.xs="100" fxLayoutGap="10px"
								fxLayoutGap.xs="10px">
								<div class="content-area" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
									<div fxLayout fxLayoutAlign="center start" class="form-container">
										<app-form-group [fieldList]="formFields" [config]="config" fxLayout="column"
											fxLayoutAlign="start stretch" fxLayout.xs="column" fxLayoutAlign.xs="start stretch"
											(formObject)="formObjectReader($event)">
										</app-form-group>
									</div>


									<app-alert id="assessment-alert"></app-alert>
								</div>
								<div fxLayout="column" fxLayoutAlign="start stretch">
									<div class="btn-block" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
										<ng-container *ngIf="action === 'createTest'">
											<button [disabled]="submitDisable" (click)="submit()" mat-stroked-button class="submit-btn"
												type="button">{{locale.translate('ok')}}</button>
										</ng-container>
										<ng-container *ngIf="action === 'updateTest'">
											<button [disabled]="submitDisable" (click)="submit()" mat-stroked-button class="submit-btn"
												type="button">{{locale.translate('update')}}</button>
										</ng-container>

										<button [disabled]="submitDisable" (click)="popupRef.close('cancel')" mat-button class="cancel-btn"
											type="button">{{locale.translate('cancel')}}</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</content-area>
	</app-form-view>
</ng-container>

<ng-container *ngIf="['addQuestion','editQuestion'].includes(action)">
	<app-form-view [popup]="true">
		<form-title>
			{{title}}
		</form-title>
		<content-area>
			<div class="assessment-form" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="30px">
				<div fxLayout="row" fxLayoutAlign="center start">
					<div fxFlex="80%" fxFlex.xs="100%" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
						<ng-container *ngIf="info">
							<div class="form-info">
								<p class="body-text">
									{{info}}
								</p>
							</div>
						</ng-container>
						<div fxLayout="row" fxLayoutAlign="center center">
							<div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="95" fxFlex.xs="100" fxLayoutGap="10px"
								fxLayoutGap.xs="10px">
								<div class="content-area" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="15px"
									[formGroup]="form">
									<div fxLayout="column" fxLayoutAlign="start stretch" class="form-container">
										<!-- <app-form-group [fieldList]="formFields" [config]="config" fxLayout="column"
											fxLayoutAlign="start stretch" fxLayout.xs="column" fxLayoutAlign.xs="start stretch"
											(formObject)="formObjectReader($event)"></app-form-group> -->
										<app-quill-editor [field]="formFields[0]" [control]="form?.controls[formFields[0]?.fieldColumn]"
											[id]="formFields[0]?.fieldColumn" [ngClass]="formFields[0]?.fieldColumn">
										</app-quill-editor>
										<div formArrayName="options">
											<ng-container *ngFor="let option of form?.controls?.options?.controls;let i = index">
												<app-text-box [field]="optionsField[i]" [control]="form?.controls?.options?.controls[i]"
													(helpLineEmit)="helpLineEmit($event, i)">
												</app-text-box>
											</ng-container>
										</div>
										<app-drop-down [field]="formFields[1]" [control]="form?.controls[formFields[1]?.fieldColumn]"
											[id]="formFields[1]?.fieldColumn" [fxFlex]="config?.fxFlex || 'auto'">
										</app-drop-down>
										<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
											<ng-container *ngIf="skillField?.length">
												<div class="block-title"> {{ locale.translate('skill') }} </div>
											</ng-container>
											<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="0px" class="form-container">
												<!-- <app-form-group [fieldList]="skillField" [config]="config" fxLayout="column"
														fxLayoutAlign="start stretch" fxLayout.xs="column" fxLayoutAlign.xs="start stretch"
														fxLayoutGap="0px" fxLayoutGap.xs="0px" (formObject)="skillFormReader($event)">
													</app-form-group> -->
												<app-auto-complete [field]="formFields[2]"
													[control]="form?.controls[formFields[2]?.fieldColumn]" [id]="formFields[2]?.fieldColumn"
													[fxFlex]="config?.fxFlex || 'auto'">
												</app-auto-complete>
											</div>
										</div>
									</div>
									<app-alert id="assessment-alert"></app-alert>
								</div>
								<div fxLayout="column" fxLayoutAlign="start stretch">
									<div class="btn-block" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
										<ng-container *ngIf="action === 'addQuestion'">
											<button [disabled]="submitDisable" (click)="submit()" mat-stroked-button class="submit-btn"
												type="button">{{locale.translate('save')}}</button>
										</ng-container>

										<ng-container *ngIf="action === 'editQuestion'">
											<button [disabled]="submitDisable" (click)="submit()" mat-stroked-button class="submit-btn"
												type="button">{{locale.translate('update')}}</button>
										</ng-container>
										<button [disabled]="submitDisable" (click)="popupRef.close('cancel')" mat-button class="cancel-btn"
											type="button">{{locale.translate('cancel')}}</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</content-area>
	</app-form-view>
</ng-container>

<ng-container *ngIf="action === 'questionDistribution' || action === 'updateAssessment'">
	<app-content-view [optionMenu]="optionMenu" (optionInfo)="optionInfo($event)">
		<content-title>
			{{title}}
		</content-title>
		<content-area>
			<div class="assessment-form" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="30px">
				<div fxLayout="row" fxLayoutAlign="center start">
					<div fxFlex="90%" fxFlex.xs="100%" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
						<div fxLayout="row" fxLayoutAlign="center center">
							<div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="95" fxFlex.xs="100" fxLayoutGap="10px"
								fxLayoutGap.xs="10px">
								<ng-container *ngIf="record?.testData">
									<div class="content-area" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="36px"
										fxLayoutGap.xs="15px">
										<div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="95" fxFlex.xs="100" fxLayoutGap="36px"
											fxLayoutGap.xs="15px">
											<ng-container *ngIf="record?.testData?.description">
												<app-common-view class="caption"
													[data]="{label: locale.translate('description'), value: record?.testData?.description}">
												</app-common-view>
											</ng-container>
											<app-common-view class="caption"
												[data]="{label: locale.translate('duration'), value: record?.testData?.duration + ' min'}">
											</app-common-view>
											<ng-container *ngIf="record?.testData?.autogenerateQuestion">
												<div class="fx-row fx-start-center chk-block">
													<mat-icon class="check-icon">check_box</mat-icon>
													<span class="caption">{{locale.translate('auto_select_questions_at_runtime')}}</span>
												</div>
											</ng-container>
										</div>
										<div class="questions-dis-container fx-column fx-start-stretch">
											<div class="fx-column fx-start-stretch fx-grow fx-shrink">
												<p class="q-dis-question block-title">
													{{locale.translate('questions_distribution')}}</p>
											</div>
											<div class="questions-block fx-column fx-start-stretch">
												<div class="chip-container fx-row-wrap fx-start-center">
													<ng-container *ngIf="!record?.testData?.autogenerateQuestion">
														<app-chips class="total_qa"
															[data]="{title: locale.translate('total_questions'), value:totalQuestions}"
															type="royal-capsule" [removable]="false" [changeFilter]="false">
														</app-chips>
													</ng-container>
													<app-chips class="total_qa"
														[data]="{title: locale.translate('total_points'), value:totalPoints}" type="royal-capsule"
														[removable]="false" [changeFilter]="false">
													</app-chips>
												</div>
												<loader [loader]="distributionLoader" [type]="'general'">
												</loader>

												<ng-container *ngIf="distributedData?.length">
													<div class="test-container fx-column fx-start-stretch fx-grow fx-shrink">
														<div class="test-card-list fx-column fx-start-stretch">
															<ng-container
																*ngFor="let data of distributedData; trackBy: gfService.trackByID.bind({'key': 'recordID'});let i = index">
																<div class="test-card-item fx-column fx-start-stretch">
																	<div class="test-header fx-row fx-space-between-center"
																		[ngClass]="{'fx-no-grow fx-shrink' : !detectDevice?.resolutionState$?.value?.xs, 'xs' : detectDevice?.resolutionState$?.value?.xs}">
																		<div class="fx-row-wrap fx-space-between-center">
																			<div class="test-item fx-row fx-start-center">
																				<span class="patch-format">{{data?.type}}</span>
																				<!-- <app-weightage class="weightage" [field]="data?.field"
																					[formControl]="data?.control" [control]="data?.control">
																				</app-weightage> -->
																				<app-chips type="progressive"
																					[data]="{title: data?.skillName, progress: data?.skillLevel + '%', toolTip: true}">
																				</app-chips>
																			</div>
																			<div class="test-item text-field fx-row fx-start-center fx-grow fx-shrink">
																				<span class="body-text fx-start-center"><b>{{data?.noOfQuestion}}</b>
																					&nbsp;{{locale.translate('questions')}},&nbsp;<b>{{data?.points}}</b>
																					&nbsp;{{locale.translate('points_each')}}</span>
																			</div>
																		</div>
																		<div class="fx-row-wrap fx-space-between-center">
																			<ng-container *ngIf="!record?.testData?.autogenerateQuestion">
																				<div class="test-item q-link fx-center-center" (click)="showQuestions(data)">
																					<ng-container *ngIf="data?.questions?.length">
																						{{locale.translate('questions')}}
																						({{data?.questions?.length}})
																					</ng-container>
																					<ng-container *ngIf="!data?.questions?.length">
																						{{locale.translate('select_questions')}}
																					</ng-container>
																				</div>
																			</ng-container>
																			<div class="fx-end-center">
																				<ng-container *ngIf="data?.action === 'editing'">
																					<button mat-icon-button class="icon-btn" #deleteBtn
																						(click)="alertPopup('deleteDistribution',data, {index: i, 'actionElement': deleteBtn})">
																						<mat-icon svgIcon="delete">
																						</mat-icon>
																					</button>
																				</ng-container>
																				<ng-container *ngIf="data?.action === 'deleting' || !data?.action">
																					<button mat-icon-button class="icon-btn" (click)="edit(data)">
																						<mat-icon svgIcon="edit">
																						</mat-icon>
																					</button>
																				</ng-container>
																			</div>
																		</div>
																	</div>
																	<ng-container *ngIf="data?.action === 'editing'">
																		<div class="test-item-body fx-column fx-start-stretch">
																			<loader [loader]="data?.loader" [type]="'general'">
																			</loader>
																			<div class="test-content fx-column fx-start-stretch">
																				<div class="field-items fx-column fx-center-start">
																					<app-form-group [fieldList]="data?.formFields" [config]="config"
																						fxLayout="column" fxLayoutAlign="start stretch" fxLayout.xs="column"
																						fxLayoutAlign.xs="start stretch"
																						(formObject)="editFormObjectReader($event, data)"
																						(removed)="removed($event, data)">
																					</app-form-group>
																				</div>
																			</div>
																			<app-alert id="distribution-update-alert">
																			</app-alert>
																			<div class="test-footer fx-column fx-start-stretch">
																				<div class="btn-block fx-row fx-center-center" fxLayotGap="8px">
																					<button mat-stroked-button class="main-btn" (click)="updateDistribution(data)"
																						[disabled]="submitDisable">{{locale.translate('ok')}}</button>
																					<button mat-button class="cancel-btn" (click)="data.action = null"
																						[disabled]="submitDisable">{{locale.translate('cancel')}}</button>
																				</div>
																			</div>
																		</div>
																	</ng-container>
																</div>
															</ng-container>

														</div>
													</div>
												</ng-container>

												<ng-container *ngIf="!canAddDistribution?.mcq && !canAddDistribution?.descriptive">
													<div class="main-links fx-row fx-start-center">
														<span class="link-item" (click)="addMcq()">+{{locale.translate('mcq')}}</span>
														<!-- <span class="link-item">+{{locale.translate('descriptive')}}</span> -->
													</div>
												</ng-container>

												<ng-container *ngIf="canAddDistribution?.mcq || canAddDistribution?.descriptive">
													<div class="test-container fx-column fx-start-stretch fx-grow fx-shrink">
														<loader [loader]="loader" [type]="'general'">
														</loader>
														<div class="test-card-list fx-column fx-start-stretch">

															<div class="test-card-item fx-column fx-start-stretch">
																<div class="test-header fx-row-wrap fx-start-center"
																	[ngClass]="{'fx-no-grow fx-shrink' : !detectDevice?.resolutionState$?.value?.xs, 'xs' : detectDevice?.resolutionState$?.value?.xs}">
																	<div class="test-item fx-row fx-start-center">
																		<span class="patch-format">
																			<ng-container *ngIf="canAddDistribution?.mcq">
																				{{locale.translate('mcq')}}
																			</ng-container>
																			<ng-container *ngIf="canAddDistribution?.descriptive">
																				{{locale.translate('descriptive')}}
																			</ng-container>
																		</span>
																	</div>
																</div>
																<div class="test-item-body fx-column fx-start-stretch">
																	<div class="test-content fx-column fx-start-stretch">
																		<div class="field-items fx-column fx-center-start">
																			<app-form-group [fieldList]="formFields" [config]="config" fxLayout="column"
																				fxLayoutAlign="start stretch" (formObject)="formObjectReader($event)">
																			</app-form-group>
																		</div>
																	</div>
																	<app-alert id="distribution-add-alert"></app-alert>
																	<div class="test-footer fx-column fx-start-stretch">
																		<div class="btn-block fx-row fx-center-center" fxLayotGap="8px">
																			<button mat-stroked-button class="main-btn" (click)="submit()"
																				[disabled]="submitDisable">{{locale.translate('ok')}}</button>
																			<button mat-button class="cancel-btn" [disabled]="submitDisable"
																				(click)="canAddDistribution.mcq = false;canAddDistribution.descriptive = false">{{locale.translate('cancel')}}</button>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</ng-container>
											</div>
										</div>
									</div>
								</ng-container>
							</div>
						</div>
					</div>
				</div>
			</div>
		</content-area>
	</app-content-view>
</ng-container>

<ng-container *ngIf="action === 'questions'">
	<app-content-view>
		<content-title>
			{{title}}
		</content-title>
		<content-area>
			<div class="select-header fx-row-wrap fx-start-center">
				<app-chips type="progressive"
					[data]="{title: record?.skillName, progress: record?.skillLevel + '%', toolTip: true}">
				</app-chips>
				<div class="qa-detail fx-row fx-space-between-stretch"
					[ngClass]="{'xs' : detectDevice?.resolutionState$?.value?.xs}">
					<ng-container
						*ngIf="![null,undefined].includes(record?.questions?.length) || ![null,undefined].includes(record?.noOfQuestion)">
						<span class="q-text"
							[innerHtml]="locale.translate('question_count_text') | handleBar : {'count': (record?.questions?.length > record?.noOfQuestion) ? record?.noOfQuestion : record?.questions?.length, 'totalCount': record?.noOfQuestion}"></span>
					</ng-container>
					<mat-divider [vertical]="true"></mat-divider>
					<span class="q-text"><b>{{record?.points}}</b>&nbsp;{{locale.translate('points_per_question')}}</span>
				</div>
				<div class="question-link" fxLayoutAlign="end end"
					[ngClass]="{'xs' : detectDevice?.resolutionState$?.value?.xs}">
					<p class="hyperlink" (click)="newQuestion()">{{locale.translate('new_question')}}</p>
				</div>
			</div>
			<div class="questions-listing" fxLayout="row" fxLayoutAlign="center center">
				<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="28px" fxLayout.xs="column"
					fxLayoutAlign.xs="start stretch" fxFlex="95" fxFlex.xs="100%">
					<div fxLayout="column" fxLayoutAlign="start stretch">
						<mat-tab-group class="custom-tab"
							[ngClass]="{'responsive-tab': detectDevice?.resolutionState$?.value?.deviceType === 'mobile'}"
							mat-align-tabs="center" [selectedIndex]="tabIndex" (selectedIndexChange)="tabChange($event)" #tab>
							<mat-tab [label]="locale.translate('selected')">
								<ng-container *ngIf="tabIndex === 0">
									<ng-container [ngTemplateOutlet]="list" [ngTemplateOutletContext]="{data: {}}">
									</ng-container>
								</ng-container>
							</mat-tab>
							<mat-tab [label]="locale.translate('select')">
								<ng-container *ngIf="tabIndex === 1">
									<ng-container [ngTemplateOutlet]="list" [ngTemplateOutletContext]="{data: {}}">
									</ng-container>
								</ng-container>
							</mat-tab>
						</mat-tab-group>
					</div>
				</div>
			</div>
			<div fxLayout="column" fxLayoutAlign="start stretch">
				<div class="btn-block" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
					<button [disabled]="submitDisable" (click)="popupRef.close('cancel')" mat-stroked-button class="close-btn"
						type="button">{{locale.translate('close')}}</button>
				</div>
			</div>
		</content-area>
	</app-content-view>
</ng-container>

<ng-template #list let-data="data">
	<div class="question-container" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="6px">
		<div class="question-block" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="34px">
			<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" fxLayout.xs="column"
				fxLayoutAlign.xs="start stretch">
				<div fxFlex="1 1" fxFlex.xs="auto" fxLayout="column" fxLayoutAlign="start stretch">
					<ng-container *ngIf="questions?.length === 0 && !loader && !formObject?.form?.controls?.search?.value">
						<div class="no-data" fxLayoutAlign="center center">
							<p>
								{{locale.translate('nothing_to_show')}}
							</p>
						</div>
					</ng-container>
					<ng-container *ngIf="questions?.length || (!questions?.length && formObject?.form?.controls?.search?.value)">
						<div class="search-form" fxLayout="row" fxLayoutAlign="center center" fxFlex="1 1" fxFlex.xs="auto">
							<div fxLayout="row" fxLayoutAlign="start stretch" fxFlex="0 1 600px" fxFlex.xs="auto" #formElement>
								<app-form-group [fieldList]="formFields" [config]="config" (formObject)="formObjectReader($event)"
									(search)="searched()" (clear)="clear()">
								</app-form-group>
							</div>
						</div>
					</ng-container>
				</div>
			</div>
			<div class="question-body" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
				<loader [loader]="loader" [type]="'general'"></loader>
				<ng-container *ngIf="questions?.length === 0 && !loader && formObject?.form?.controls?.search?.value">
					<div class="no-data" fxLayout="row" fxLayoutAlign="center center">
						<p>
							{{locale.translate('nothing_to_show')}}
						</p>
					</div>
				</ng-container>
				<ng-container *ngIf="questions?.length">
					<app-common-list [layout]="'column'" [layoutGap]="'20px'" [count]="questionCount"
						(loadMoreData)="getQuestion($event)">
						<list-item
							*ngFor="let question of questions; trackBy: gfService.trackByID.bind({'key': 'ID'});let i = index">
							<content-area fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="24px">
								<div class="select-body fx-column fx-start-stretch">
									<div class="question-list fx-column fx-start-stretch">
										<div class="question-item fx-row fx-space-between-center">
											<ng-container *ngIf="![null,undefined].includes(question?.question)">
												<div class="question-content cursor-pointer fx-column fx-start-stretch fx-grow fx-shrink"
													[innerHtml]="question?.question | safeDom" (click)="viewQuestions(question)">
													<!-- <span class="question"></span> -->
													<div class="fx-row fx-start-center">
														<app-chips type="progressive"
															[data]="{title: question?.skill?.name, progress: question?.skillLevel + '%', toolTip: true}">
														</app-chips>
														<!-- <span class="mark-info">1 points</span> -->
													</div>
												</div>
											</ng-container>
											<ng-container *ngIf="question?.action === 'select'">
												<span class="hyperlink" (click)="addQuestion(question)">{{locale.translate('select')}}</span>
											</ng-container>
											<ng-container *ngIf="question?.action === 'remove'">
												<span class="hyperlink" (click)="removeQuestion(question)">{{locale.translate('remove')}}</span>
											</ng-container>
										</div>
									</div>
								</div>
							</content-area>
						</list-item>
					</app-common-list>
				</ng-container>
			</div>
		</div>
	</div>
</ng-template>

<ng-container *ngIf="action === 'viewQuestion'">
	<app-content-view [optionMenu]="optionMenu" (optionInfo)="optionInfo($event)">
		<content-title>
			{{title}}
		</content-title>
		<content-area>
			<div class="question-container" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="28px"
				fxLayoutGap.xs="15px">
				<loader [loader]="loader" [type]="'general'">
				</loader>
				<ng-container *ngIf="![null,undefined].includes(record?.question)">
					<p class="question" [innerHtml]="record?.question | safeDom"></p>
				</ng-container>
				<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="22px" fxLayoutGap.xs="15px">
					<!-- <div > -->

					<div class="question-block" fxFlex="1 1" fxLayout="column wrap" fxLayoutAlign="space-between start">
						<ng-container
							*ngFor="let option of record.details.options; trackBy: gfService.trackByID.bind({'key': 'index'})">
							<div class="option"
							[ngClass]="{'entity-title': option?.index === record?.details?.rightOption }"
							 fxFlex="0 1 auto" fxFlex.xs="auto" fxLayout="row" fxLayoutAlign="start center"
								fxLayoutGap="5px">
								<p class="question" [innerHtml]="option?.option | safeDom"></p>
							</div>
						</ng-container>
					</div>
					<app-chips type="progressive"
						[data]="{title: record?.skill.name, progress: record?.skillLevel + '%', toolTip: true}">
					</app-chips>
					<!-- </div> -->
					<!-- <ng-container *ngIf="record.answer">
						<mat-checkbox class="chk-icon" [(ngModel)]="record.markForReview">
							<span class="caption">{{locale.translate('mark_for_review')}}</span>
						</mat-checkbox>
					</ng-container> -->
				</div>
			</div>


			<div fxLayout="column" fxLayoutAlign="start stretch">
				<div class="btn-block" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
					<button [disabled]="submitDisable" (click)="viewQuestionCloseBtn()" mat-stroked-button class="close-btn"
						type="button">{{locale.translate('close')}}</button>
				</div>
			</div>
		</content-area>
	</app-content-view>
</ng-container>